import { SxProps } from '@mui/material'

interface FilterDropdownResponsiveStyles {
  contentWrapper: SxProps
}

export const filterDropdownResponsiveStyles: FilterDropdownResponsiveStyles = {
  contentWrapper: {
    maxHeight: '50svh',
  },
}
